import { __extends } from "tslib";
import { StopStreamEncryptionInput } from "../models/models_0";
import { deserializeAws_json1_1StopStreamEncryptionCommand, serializeAws_json1_1StopStreamEncryptionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StopStreamEncryptionCommand = /** @class */ (function (_super) {
    __extends(StopStreamEncryptionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StopStreamEncryptionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StopStreamEncryptionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "StopStreamEncryptionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: StopStreamEncryptionInput.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StopStreamEncryptionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StopStreamEncryptionCommand(input, context);
    };
    StopStreamEncryptionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StopStreamEncryptionCommand(output, context);
    };
    return StopStreamEncryptionCommand;
}($Command));
export { StopStreamEncryptionCommand };
//# sourceMappingURL=StopStreamEncryptionCommand.js.map